import { useState, useEffect } from "react";
import { ROADMAP } from "@/constants/testIds/roadmap";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const links = [
  { id: "summary", label: "Summary" },
  { id: "phases", label: "Roadmap" },
  { id: "modules", label: "Modules" },
  { id: "gr8agentic", label: "Gr8Agentic AI" },
  { id: "whitelabel", label: "White-Label" },
  { id: "kpis", label: "KPIs" },
  { id: "integrations", label: "Integrations" },
  { id: "roles", label: "Roles" },
  { id: "risks", label: "Risks" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <nav
      data-testid={ROADMAP.nav}
      className={`fixed top-0 left-0 right-0 z-50 bg-white border-b border-[#DEE2E6] transition-shadow ${
        scrolled ? "shadow-[0_1px_0_0_#DEE2E6]" : ""
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <button
          onClick={() => scrollTo("top")}
          className="flex items-center gap-2 group"
          data-testid="nav-logo"
        >
          <Logo size={32} />
          <span className="hidden sm:inline text-[10px] uppercase tracking-[0.2em] text-[#495057] ml-2 border-l border-[#DEE2E6] pl-2">
            with Gr8Agentic AI
          </span>
        </button>

        <ul className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <li key={l.id}>
              <button
                onClick={() => scrollTo(l.id)}
                data-testid={ROADMAP.navLink(l.id)}
                className="px-3 py-2 text-sm text-[#0A0A0A] hover:text-[#0033A0] hover:bg-[#F8F9FA] rounded-sm transition-colors duration-200"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>

        <button
          onClick={() => scrollTo("cta")}
          className="hidden lg:inline-flex items-center bg-[#0A0A0A] hover:bg-[#0033A0] text-white text-sm font-medium px-4 py-2 rounded-sm transition-colors duration-200"
          data-testid="nav-cta"
        >
          Request a demo →
        </button>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2"
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#DEE2E6] bg-white">
          <ul className="px-6 py-4 grid gap-1">
            {links.map((l) => (
              <li key={l.id}>
                <button
                  onClick={() => scrollTo(l.id)}
                  data-testid={`mobile-${ROADMAP.navLink(l.id)}`}
                  className="w-full text-left px-3 py-2 text-sm hover:bg-[#F8F9FA] rounded-sm"
                >
                  {l.label}
                </button>
              </li>
            ))}
            <li>
              <button
                onClick={() => scrollTo("cta")}
                className="w-full text-left px-3 py-2 mt-2 bg-[#0A0A0A] text-white rounded-sm"
              >
                Request a demo →
              </button>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}
